import { render, staticRenderFns } from "./informacion_actasentrega.vue?vue&type=template&id=bfbdf1e8&scoped=true"
import script from "./informacion_actasentrega.vue?vue&type=script&lang=js"
export * from "./informacion_actasentrega.vue?vue&type=script&lang=js"
import style0 from "./informacion_actasentrega.vue?vue&type=style&index=0&id=bfbdf1e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbdf1e8",
  null
  
)

export default component.exports